import BaseCheckbox from 'components/atoms/baseCheckbox';
import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { useFilter } from './filter/use-filter';
import s from './styles.module.scss';

export const SelectPrograms: FC = () => {
  const { t } = useTranslation();
  const { filter, updateFilter } = useFilter();

  return (
    <div className={s['form-group']}>
      <label className={s.bold}>{t('labels.selectPrograms')}</label>

      <BaseCheckbox
        label="CCM"
        checked={!!filter.ccm}
        onChange={(value: boolean) => {
          updateFilter({ ccm: value });
        }}
      />
      <BaseCheckbox
        label="PCM"
        checked={!!filter.pcm}
        onChange={(value: boolean) => {
          updateFilter({ pcm: value });
        }}
      />
    </div>
  );
};
